/** Always returns a string — safe for MUI Autocomplete getOptionLabel and Chip labels. */
export const displayText = (value, fallback = "") => {
  if (value == null || value === "") return fallback;
  if (typeof value === "string" || typeof value === "number") return String(value);
  if (typeof value === "object") {
    if (typeof value.name === "string" && value.name.trim()) return value.name;
    if (value._id) return String(value._id);
  }
  return fallback;
};

export const itemCatalogLabel = (item) => {
  if (!item || typeof item !== "object") return "Unknown item";
  const name = displayText(item.name, "");
  if (name) return name;
  if (item.uniformGroup) {
    const parts = [
      displayText(item.uniformGroup, ""),
      displayText(item.size, ""),
    ].filter(Boolean);
    if (parts.length) return parts.join(" — ");
  }
  return displayText(item._id, "Unknown item");
};

export const collectionCatalogLabel = (col) => {
  const name = displayText(col?.name, "");
  return name ? `[Set] ${name}` : `[Set] ${displayText(col?._id, "Unknown")}`;
};

export const buildCatalogItemOptions = (catalog) => {
  if (!catalog) return [];
  const items = (catalog.items || [])
    .filter((it) => it && it._id)
    .map((it) => ({
      label: itemCatalogLabel(it),
      id: String(it._id),
      isCollection: false,
    }));
  const collections = (catalog.collections || [])
    .filter((col) => col && col._id)
    .map((col) => ({
      label: collectionCatalogLabel(col),
      id: String(col._id),
      isCollection: true,
    }));
  return [...items, ...collections];
};

export const resolveCatalogLineLabel = (itemId, isCollection, options) => {
  const id = displayText(itemId, "");
  const opt = options.find(
    (o) => o.id === id && o.isCollection === isCollection
  );
  if (opt?.label) return opt.label;
  if (typeof itemId === "object" && itemId) {
    return isCollection
      ? collectionCatalogLabel(itemId)
      : itemCatalogLabel(itemId);
  }
  return `${isCollection ? "[Set]" : "[Item]"} ${id || "?"}`;
};
